import { get, del, post, put } from "@utils/axios";

const api = "servers";

export const getAllServers = (payload) => {
  return get(`${api}`)
};

export const createDataReq = (payload) => {
  return post(`${api}?`, payload);
};

export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload);
};

export const deleteDataReq = (id) => {
  return del(`${api}/${id}`);
};
